import React from 'react';
import PropTypes from 'prop-types';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import Button from '../../Button';

const ClearRefinements = ({ items, refine, label }) => {
  if (!items.length) {
    return null;
  }

  return (
    <Button color="link" className="p-0" onClick={() => refine(items)}>
      {label}
    </Button>
  );
};

ClearRefinements.propTypes = {
  items: PropTypes.array,
  label: PropTypes.string,
  refine: PropTypes.func,
};

ClearRefinements.defaultProps = {
  items: [],
  label: undefined,
  refine: undefined,
};

export default connectCurrentRefinements(ClearRefinements);
